export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 5_15.ce0c6322.jpg";